import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { buildHttpPost, buildHttpPostWithBody } from "./utils/backendInterface.js";
import { isDev } from "./utils/helper.js";

const CreateTerminals = () => {
    const navigate = useNavigate();
    let count = 0;
    let _isDev = isDev();
    let accessToken = sessionStorage.getItem("accessToken");
    if (!accessToken) {
      navigate('/sign-in');
    }

    const [terminals, setTerminals] = useState([
      { serialNumber: "", posId: "", terminalName: "" }
    ]);
    const [error, setError] = useState("");

    const [companyId, setCompanyId] = useState(() => {
        // Initialize from URL or sessionStorage
        let pathArray = window.location.pathname.split('/');
        if (pathArray.length > 2 && pathArray[1] === "companies" && pathArray[2] !== undefined) {
            sessionStorage.setItem("lastSelectedCompany", pathArray[2]);
            return pathArray[2];
        } else {
            return sessionStorage.getItem("lastSelectedCompany");
        }
    });

    const [groupId, setGroupId] = useState(() => {
        // Initialize from URL or sessionStorage
        let pathArray = window.location.pathname.split('/');
        if (pathArray.length > 2 && pathArray[3] === "groups" && pathArray[4] !== undefined) {
            sessionStorage.setItem("lastSelectedGroup", pathArray[4]);
            return pathArray[4];
        } else {
            return sessionStorage.getItem("lastSelectedGroup");
        }
    });

    const handleChange = (index, field, value) => {
      const updated = [...terminals];
      updated[index][field] = value;
      setTerminals(updated);

      // Add new row automatically if last row has any data
      if (
        index === terminals.length - 1 &&
        (updated[index].serialNumber || updated[index].posId || updated[index].terminalName)
      ) {
        setTerminals([
          ...updated,
          { serialNumber: "", posId: "", terminalName: "" }
        ]);
      }
    };

    const onSubmitHandler = (event) => {
      event.preventDefault();
      console.log("onSubmitHandler CreateTerminals");

      let filledTerminals = terminals.filter(
        (t) => t.serialNumber.trim() !== "" // keep only rows with serial number
      );

      if (filledTerminals.length === 0) {
        setError("⚠️ Please enter at least one terminal (Serial Number required).");
        return;
      }

      setError(""); // clear error if validation passes

      let newTerminalsJson = {
        companyId: companyId,
        groupId: groupId,
        terminals: filledTerminals,
      };

      function alertContents(httpRequest) {
          if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
              console.log("httpRequest.status: " + httpRequest.status);
          }
      }

      let requestParams = new Map();
      requestParams.set("accessToken", accessToken);

      const httpPost = buildHttpPostWithBody(
          `companies/${companyId}/groups/${groupId}/add-terminals`,
          requestParams,
          alertContents,
          JSON.stringify(newTerminalsJson)
      );
      httpPost.sendRequest();
    };

    useEffect(() => {
        count = count + 1;
        console.log("On page load: " + count);
        if (count === 1 && _isDev) {
            return;
        }
        if (!accessToken) {
            navigate('/sign-in');
            return;
        } else if (!sessionStorage.getItem("accessToken")) {
            return;
        }

        // Handle initial navigation if needed
        if (companyId && groupId && window.location.pathname !== `/companies/${companyId}/groups/${groupId}/create-terminals`) {
            console.log(`Re-navigation required to: /companies/${companyId}/groups/${groupId}/create-terminals`);
            navigate(`/companies/${companyId}/groups/${groupId}/create-terminals`);
        }
    }, [count]);

    return (
      <div id="create-terminals">
        <h2>Create Terminals</h2>
        <div className="content-box">
          <form onSubmit={onSubmitHandler}>
            <table>
              <thead>
                <tr>
                  <th>Serial Number *</th>
                  <th>Pos ID</th>
                  <th>Terminal Name</th>
                </tr>
              </thead>
              <tbody>
                {terminals.map((t, index) => (
                  <tr key={index}>
                    <td>
                      <input
                        type="text"
                        value={t.serialNumber}
                        onChange={(e) =>
                          handleChange(index, "serialNumber", e.target.value)
                        }
                        style={{ width: "100%", padding: "5px", border: "1px solid #ddd", borderRadius: "4px" }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={t.posId}
                        onChange={(e) =>
                          handleChange(index, "posId", e.target.value)
                        }
                        style={{ width: "100%", padding: "5px", border: "1px solid #ddd", borderRadius: "4px" }}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={t.terminalName}
                        onChange={(e) =>
                          handleChange(index, "terminalName", e.target.value)
                        }
                        style={{ width: "100%", padding: "5px", border: "1px solid #ddd", borderRadius: "4px" }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {error && (
              <p style={{ color: "red", marginTop: "10px" }}>{error}</p>
            )}
            <button type="submit" className="submit-button">
              Submit Terminals
            </button>
          </form>
        </div>
      </div>
    );
};

export default CreateTerminals;
